import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { App, URLOpenListenerEvent } from '@capacitor/app';

const AppUrlListener = () => {
    let history = useHistory();
    useEffect(() => {
        App.addListener('appUrlOpen', (event) => {
            if (event.url.indexOf('/#/') >= 0) {
                const newPage = event.url.split('/#/').pop();
                console.log('App opened with URL:', event.url, 'Navigating to page:', newPage);
                if (newPage) {
                    history.push("/"+newPage);
                }
            } 
        });
        return () => {
            App.removeAllListeners();
        };
    }, []);

    return null;
};

export default AppUrlListener;